/*! xtend-magento (https://getxtend.com/)
@copyright (c) 2017 - 2018 Riccardo Caroli
@license MIT (https://github.com/minimit/xtend-library/blob/master/LICENSE) */

import '../xtend-library/scripts/xtend';

//////////////////////
// Util
//////////////////////

const isVisible = (el) => {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)
}

//////////////////////
// Magento
//////////////////////

// filter search

let filterSearch = function (added) {
  let containers = added.querySelectorAll('.filter-search-container');
  if (containers.length) {
    for (let container of containers) {
      // populate

      const search = container.querySelector('[data-js-filter-search]')
      const items = container.querySelectorAll('[data-js-filter-item]')
      const collapseTarget = container.querySelector('.show-more')
      if (!search || !items.length || !collapseTarget) continue

      // find

      const find = () => {
        const val = search.value.toLowerCase()
        if (val.length > 0) {
          for (const item of items) {
            const name = item.querySelector('[data-js-filter-item-name]')
            const found = name.innerText.toLowerCase().includes(val)
            if (found) {
              item.classList.remove('hide')
              item.classList.add('show-active')
            } else {
              item.classList.add('hide')
              item.classList.remove('show-active')
            }
          }
        } else {
          for (const item of items) {
            item.classList.remove('hide')
            item.classList.add('show-active')
          }
        }
        collapseTarget.classList.add('hide')
        collapseTarget.classList.remove('show-active')
      }

      search.addEventListener('keyup', find)
    }
  }
};

Xt.initArr.push(filterSearch); // on DOM ready and on content added to DOM

// checkout copy shipping form

function copyCheckoutCopyShippingForm() {
  const formFrom = document.querySelector('.form-shipping-address');
  const formTo = document.querySelector('.billing-address-form');
  if (formFrom && formTo) {
    const inputs = formFrom.querySelectorAll('input, select');
    for (const input of inputs) {
      const name = input.getAttribute('name');
      const inputTo = formTo.querySelector('[name="' + name + '"]');
      if (inputTo) {
        inputTo.value = input.value;
        inputTo.dispatchEvent(new CustomEvent('change'))
      }
    }
  }
}

function initCheckoutCopyShippingForm(added) {
  const btn = added.querySelector('#checkout-copy-shipping-form');
  if (btn) {
    if (isVisible(btn)) {
      btn.addEventListener('click', copyCheckoutCopyShippingForm);
    } else {
      // hide when logged in and form is not visible
      const field = btn.closest('.field');
      if (field) {
        field.classList.add('display-none');
      }
    }
  }
}

Xt.initArr.push(initCheckoutCopyShippingForm); // on DOM ready and on content added to DOM

// checkoutLogin

let checkoutLogin = function (added) {
  let els = added.querySelectorAll('#overlay-checkout-login');
  if (els.length) {
    let btns = document.querySelectorAll('#btn-checkout-login');
    for (let [i, btn] of btns.entries()) {
      if (!btn.dataset.checkoutLoginDone) {
        btn.dataset.checkoutLoginDone = 'true';
        // assign overlay
        new Xt.Overlay(btn, {
          "targets": "#overlay-checkout-login"
        });
      }
    }
  }
};

Xt.initArr.push(checkoutLogin); // on DOM ready and on content added to DOM

// populateQty

let populateQty = function (added) {
  let els = added.querySelectorAll('input.qty, input.item-qty');
  if (els.length) {
    for (let [i, el] of els.entries()) {
      if (!el.dataset.populateQtyDone) {
        el.dataset.populateQtyDone = 'true';
        // populate
        let control = el.parentNode;
        let html = control.innerHTML;
        control.classList.add('group');
        control.classList.add('group-number');
        control.classList.add('group-number-line');
        control.innerHTML = '<span class="group-inner">' +
          '<button type="button" class="btn group-number-remove"><span>-</span></button>' +
          '</span>';
        control.innerHTML += html;
        control.innerHTML += '<span class="group-inner">' +
          '<button type="button" class="btn group-number-add"><span>+</span></button>' +
          '</span>';
        // magento
        if (el.getAttribute('data-validate')) {
          let error = false;
          try {
            JSON.parse(el.getAttribute('data-validate'));
          } catch (e) {
            error = true;
          }
          if (!error) {
            let options = JSON.parse(el.getAttribute('data-validate'));
            let input = control.querySelectorAll('input')[0];
            let min = options['validate-item-quantity']['minAllowed'];
            let max = options['validate-item-quantity']['maxAllowed'];
            let step = options['validate-item-quantity']['qtyIncrements'];
            if (min) {
              input.setAttribute('min', min);
            }
            if (max) {
              input.setAttribute('max', max);
            }
            if (step) {
              input.setAttribute('step', step);
            }
          }
        }
      }
    }
  }
};

Xt.initArr.push(populateQty); // on DOM ready and on content added to DOM

// group validation

let groupValidation = function (added) {
  if (added.classList.contains('mage-error')) {
    // populate
    let group = added.parentNode;
    if (group.classList.contains('group')) {
      if (!added.dataset.groupValidationDone) {
        added.dataset.groupValidationDone = 'true';
        group.parentNode.appendChild(added);
      }
    }
  }
};

Xt.initArr.push(groupValidation); // on DOM ready and on content added to DOM

/*
// overlayMessages

let overlayMessages = function (added) {
  if (added.classList.contains('message')) {
    if (!added.dataset.overlayMessagesDone) {
      added.dataset.overlayMessagesDone = 'true';
      // overlay
      if (!document.querySelectorAll('#overlay-messages').length) {
        let overlay = Xt.createElement(
          '<div class="overlay-outer active" id="overlay-messages" data-xt-overlay>' +
          '<div class="overlay"><div class="overlay-inner">' +
          '<button type="button" class="btn btn-close"><span></span></button>' +
          '<div class="content event-limit"></div>' +
          '</div></div>' +
          '</div>');
        document.documentElement.appendChild(overlay);
      }
      // populate
      document.querySelectorAll('#overlay-messages .content')[0].appendChild(added);
    }
  }
};

for (let [i, el] of document.querySelectorAll('.message').entries()) {
  overlayMessages(el);
}
*/

//////////////////////
// xtend extension: group-number
//////////////////////

function inputNumberValidate(val) {
  let group = this;
  let input = group.querySelectorAll('input')[0];
  let addEl = group.querySelectorAll('.group-number-add')[0];
  let removeEl = group.querySelectorAll('.group-number-remove')[0];
  // disabled
  addEl.removeAttribute('disabled');
  removeEl.removeAttribute('disabled');
  // check min and max
  let inputMin = parseFloat(input.getAttribute('min')) || 1;
  let inputMax = parseFloat(input.getAttribute('max')) || Infinity;
  if (val <= inputMin) {
    val = inputMin;
    removeEl.setAttribute('disabled', 'disabled');
  }
  if (val >= inputMax) {
    val = inputMax;
    addEl.setAttribute('disabled', 'disabled');
  }
  // set value
  input.value = val;
  input.dispatchEvent(new CustomEvent('change', {bubbles: true, detail: {skip: true}}));
}

function inputNumberChange(step, e) {
  if (!e || !e.detail || !e.detail.skip) {
    let group = this;
    let input = group.querySelectorAll('input')[0];
    let val = parseFloat(input.value);
    val = val + step;
    inputNumberValidate.bind(group)(val);
  }
}

function inputNumberInit(added) {
  let groups = added.querySelectorAll('.group-number');
  if (groups.length) {
    for (let [i, group] of added.querySelectorAll('.group-number').entries()) {
      // init
      inputNumberChange.bind(group, 0)();
      // vars
      let inputEl = group.querySelectorAll('input')[0];
      let step = parseFloat(inputEl.getAttribute('step')) || 1;
      // add
      let addEl = group.querySelectorAll('.group-number-add')[0];
      let addStep = step;
      let addHandler = Xt.dataStorage.get(addEl, 'addHandler');
      addHandler = addHandler ? addHandler : Xt.dataStorage.put(addEl, 'addHandler', inputNumberChange.bind(group, addStep));
      addEl.removeEventListener('click', addHandler);
      addEl.addEventListener('click', addHandler);
      // remove
      let removeEl = group.querySelectorAll('.group-number-remove')[0];
      let removeStep = -step;
      let removeHandler = Xt.dataStorage.get(removeEl, 'removeHandler');
      removeHandler = removeHandler ? removeHandler : Xt.dataStorage.put(removeEl, 'removeHandler', inputNumberChange.bind(group, removeStep));
      removeEl.removeEventListener('click', removeHandler);
      removeEl.addEventListener('click', removeHandler);
      // change
      let inputHandler = Xt.dataStorage.get(inputEl, 'inputHandler');
      inputHandler = inputHandler ? inputHandler : Xt.dataStorage.put(inputEl, 'inputHandler', inputNumberChange.bind(group, 0));
      inputEl.removeEventListener('change', inputHandler);
      inputEl.addEventListener('change', inputHandler);
    }
  }
}

Xt.initArr.push(inputNumberInit); // on DOM ready and on content added to DOM

//////////////////////
// xtend extension: menumobile
//////////////////////

function initMenumobileReset(added) {
  let btns = added.querySelectorAll('.menumobile_reset');
  let btnReset = added.querySelectorAll('#menumobile_tab_reset')[0];
  if (btns.length) {
    for (let [i, btn] of btns.entries()) {
      btn.addEventListener('click', function (e) {
        if (!e.detail || !e.detail.skipToggle) {
          btnReset.dispatchEvent(new CustomEvent('on', {detail: {skipToggle: true}}));
        }
      });
    }
  }
}

Xt.initArr.push(initMenumobileReset); // on DOM ready and on content added to DOM

//////////////////////
// #newsletter-cats
//////////////////////

function initNewsletterCats(added) {
  let btns = added.querySelectorAll('#newsletter-cat-cats .btn');
  if (btns.length) {
    // vars
    let btnAll = added.querySelectorAll('#newsletter-cat-all');
    let inputArr = [];
    let inputAll = added.querySelectorAll('#newsletter-cats')[0];
    // set value
    let changeNewsletterCat = function () {
      inputAll.value = inputArr.join(', ');
      console.debug('newsletter values:', inputAll.value);
    };
    // events
    for (let [i, btn] of btns.entries()) {
      btn.addEventListener('on', function (e) {
        if (!e.detail || !e.detail.skipToggle) {
          inputArr.push(btn.getAttribute('data-value'));
          changeNewsletterCat();
          if (btnAll.length) {
            btnAll[0].dispatchEvent(new CustomEvent('off', {detail: {skipToggle: true}}));
          }
        }
      });
      btn.addEventListener('off', function (e) {
        if (!e.detail || !e.detail.skipToggle) {
          inputArr = inputArr.filter(function (value) {
            return value !== btn.getAttribute('data-value');
          });
          changeNewsletterCat();
          if (btnAll.length) {
            btnAll[0].dispatchEvent(new CustomEvent('off', {detail: {skipToggle: true}}));
          }
        }
      });
    }
    if (btnAll.length) {
      btnAll[0].addEventListener('on', function (e) {
        if (!e.detail || !e.detail.skipToggle) {
          inputArr = [];
          for (let [i, btn] of btns.entries()) {
            inputArr.push(btn.getAttribute('data-value'));
            btn.dispatchEvent(new CustomEvent('on', {detail: {skipToggle: true}}));
          }
          changeNewsletterCat();
        }
      });
      btnAll[0].addEventListener('off', function (e) {
        if (!e.detail || !e.detail.skipToggle) {
          inputArr = [];
          for (let [i, btn] of btns.entries()) {
            btn.dispatchEvent(new CustomEvent('off', {detail: {skipToggle: true}}));
          }
          changeNewsletterCat();
        }
      });
    }
  }
}

Xt.initArr.push(initNewsletterCats); // on DOM ready and on content added to DOM

//////////////////////
// search focus
//////////////////////

function searchFocus(added) {
  let drop = added.querySelector('.search-wrapper .drop-outer');
  if (drop) {
    drop.addEventListener('on', function () {
      var input = drop.querySelector('input')
      input.value = ''
      input.focus()
    });
  }
}

Xt.initArr.push(searchFocus); // on DOM ready and on content added to DOM

//////////////////////
// search no autoclose
//////////////////////

Xt.autoClose = function() {

}

//////////////////////
// .banner-rotator
//////////////////////

  const bannerRotator = function(main) {
    // vars

    const container = main
    if (container.closest('.xt-clone')) return
    const items = container.querySelectorAll('.banner-rotator-item')
    const time = parseFloat(container.getAttribute('data-time')) || 8000
    let i = 0

    // change

    const change = () => {
      let bannerHeight = 0
      for (const item of items) {
        item.classList.add('loaded')
        item.classList.remove('active')
        const height = item.querySelector('.banner-rotator-item-content').offsetHeight
        bannerHeight = height > bannerHeight ? height : bannerHeight
      }
      items[i].classList.add('active')
      container.style.height = bannerHeight + 'px'
      var productContainer = document.querySelector('.product-page')
      if (productContainer) {
        productContainer.style.paddingTop = bannerHeight + 'px'
      }
      i++
      i = i >= items.length ? 0 : i
      // header
      if (container.classList.contains('banner-rotator-height')) {
        const header = document.querySelector('.header:not(.xt-clone) .header_inner')
        let headerHeight = 0
        if (header) {
          headerHeight = header.offsetHeight
        }
        // slides
        const slides = document.querySelectorAll('.slider--home_img')
        if (slides.length) {
          let slideheight = window.innerHeight
          if (!document.querySelector('.header-transparent') || matchMedia('(max-width: 991px)').matches) {
            slideheight -= bannerHeight + headerHeight
          }
          for (const slide of slides) {
            slide.style.height = slideheight + 'px'
          }
        }
        // menu mobile
        const menu_mobile = document.querySelector('#overlay-menu-mobile .overlay_inner')
        if (menu_mobile) {
          const menuPaddingTop = bannerHeight + headerHeight
          menu_mobile.style.paddingTop = menuPaddingTop + 'px'
        }
      }
    }

    if (items.length > 1) {
      setInterval(change, time)
    }
    change()
  };

  for (const banner of document.querySelectorAll('.banner-rotator')) {
    bannerRotator(banner)
  }
